var React = require('react');

function CloseCartIcon (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Select to close mini cart"),React.createElement("path",{"d":"M13 1.00109L1 13M13 13L1.00055 1","stroke":"#22202F","strokeLinecap":"round","strokeLinejoin":"round","key":1})]);
}

CloseCartIcon.defaultProps = {"width":"14","height":"14","viewBox":"0 0 14 14","fill":"none"};

module.exports = CloseCartIcon;

CloseCartIcon.default = CloseCartIcon;
